export default __webpack_public_path__ + "static/media/MusicalIntruments_36.ba6e2f28.png";